// ข้อมูลบริษัทผู้ออกเอกสาร (JosCoWork) — ใช้ซ้ำได้ทุกเอกสาร (ใบเสร็จ/ใบกำกับภาษี/ใบแจ้งหนี้/ใบเสนอราคา)
// hardcode ไว้ก่อนตามที่ตกลงกัน (2026-09-29) — ยังไม่ทำหน้าตั้งค่าแยกเพราะข้อมูลนี้ไม่น่าเปลี่ยนบ่อย
export const JOSCOWORK_COMPANY = {
  name: 'บริษัท ทำน้อยได้มาก จำกัด (สำนักงานใหญ่)',
  addressLine1: '113/3 ซอยลาดพร้าว 101 ซอย 48 (บ่อปลา) แขวงคลองจั่น',
  addressLine2: 'เขตบางกะปิ กรุงเทพมหานคร 10240',
  tel: '0949541945',
  taxId: '0105558166516',
  bankName: 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน)',
  bankAccountNumber: '406-939434-3',
}

// ราคาเหมาต่อวันของการอบรม In-house — คงที่ทุกคอร์ส ไม่ขึ้นกับจำนวนผู้เข้าอบรม (2026-09-30)
export const INHOUSE_DAILY_RATE = 35000
